<template>
  <div>
    <div class="footer-copyright">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div
              class="
                copyright-item
                d-block d-md-flex
                justify-content-center
                align-items-center
              "
            >
              <p class="pr-2">
                <a href="https://beian.miit.gov.cn" target="_blank" style="color: #337ab7;">
                  京ICP备2025143440号
                </a>
              </p>

              <p>© Copyright 2025-2026, All Rights Reserved</p>

              <!--
              <ul>
                <li><a href="#">About</a></li>
                <li><a href="#">Advertise</a></li>
                <li><a href="#">Privacy & Policy</a></li>
                <li><a href="#">Contact Us</a></li>
              </ul>
              -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
